import type { ReportAuthorizationInfo } from "../../../../../../api/types/svTypes.ts";
import { ReportTypesEnum } from "../types/reportTypes";

export interface ReportListItem {
  name: string;
  group: string;
  createdBy: string;
  modifiedBy?: string;
  authorization: Pick<ReportAuthorizationInfo, "own">;
}

const matchesSearch = <T extends ReportListItem>(item: T, searchText: string, getId: (item: T) => string): boolean =>
  item.name.toLowerCase().includes(searchText) ||
  item.group.toLowerCase().includes(searchText) ||
  item.createdBy.toLowerCase().includes(searchText) ||
  (item.modifiedBy?.toLowerCase().includes(searchText) ?? false) ||
  getId(item).toLowerCase() === searchText;

export const filterReportList = <T extends ReportListItem>(
  items: T[],
  searchText: string,
  getId: (item: T) => string
): Record<ReportTypesEnum, T[]> => {
  const normalizedSearchText = searchText.trim().toLowerCase();
  const matchingItems = items.filter((item) => matchesSearch(item, normalizedSearchText, getId));
  return {
    [ReportTypesEnum.All]: matchingItems,
    [ReportTypesEnum.MyReports]: matchingItems.filter((item) => item.authorization.own),
    [ReportTypesEnum.SharedWithMe]: matchingItems.filter((item) => !item.authorization.own),
  };
};
